import React, { createContext, useContext, ReactNode } from 'react';

/**
 * Context to track if we're in onboarding flow.
 * Used ONLY for structural/behavioral differences (showing/hiding UI elements),
 * NOT for styling. All styling should be handled by the theme.
 */
interface OnboardingContextValue {
  isOnboarding: boolean;
}

const OnboardingContext = createContext<OnboardingContextValue>({
  isOnboarding: false,
});

export const useIsOnboarding = () => {
  const context = useContext(OnboardingContext);
  return context.isOnboarding;
};

// Keep for backward compatibility during migration
export const useOnboardingTheme = () => {
  return useContext(OnboardingContext);
};

interface OnboardingProviderProps {
  children: ReactNode;
  isOnboarding?: boolean;
}

export const OnboardingProvider = ({ children, isOnboarding = false }: OnboardingProviderProps) => {
  return (
    <OnboardingContext.Provider value={{ isOnboarding }}>{children}</OnboardingContext.Provider>
  );
};
